<template>
  <div v-if="showSelectedFilters" class="elements-list smaller-elements">
    <FilterLabel
      v-for="item in array"
      :key="item"
      :label="item"
      :is-selected="true"
      :with-clear-icon="true"
      @on-clear="onDeleteFilterValue(item)"
    />
  </div>
</template>

<script>
import { computed, toRaw } from 'vue';

import { FILTER_TYPE } from '~/constants/documents';

import useFormFilters from '~/composables/useFormFilters';
import useConversations from '~/composables/useConversations';

import FilterLabel from '~/components/filters/FilterLabel.vue';

export default {
  components: { FilterLabel },
  setup() {
    const { formFilters, setFiltersObject } = useFormFilters();
    const { isFilterFormDisabled } = useConversations();

    const array = computed(() => {
      const rawFormFilters = toRaw(formFilters.value[FILTER_TYPE.document]);
      if (!rawFormFilters) {
        return [];
      }
      const flatArray = Object.values(rawFormFilters).flat();

      return flatArray;
    });

    const showSelectedFilters = computed(() => array.value.length && !isFilterFormDisabled.value);

    const onDeleteFilterValue = (item) => {
      const rawFormFilters = toRaw(formFilters.value[FILTER_TYPE.document]);
      if (!rawFormFilters) {
        return;
      }

      const newValues = Object.fromEntries(
        Object.entries(rawFormFilters).map(([k, v]) => [k, Array.isArray(v) ? v.filter((x) => x !== item) : v]),
      );

      setFiltersObject({ [FILTER_TYPE.document]: newValues });
    };

    return { array, showSelectedFilters, onDeleteFilterValue };
  },
};
</script>

<style scoped lang="scss">
.elements-list {
  display: flex;
  height: fit-content;
  gap: $bb-spacing-1;
  flex-wrap: wrap;
  flex-direction: row;

  :deep(.bb-btn.secondary) {
    border-radius: 100px !important;
    padding: 10px $bb-spacing-4 !important;
    height: $bb-spacing-9 !important;
  }

  :deep(.v-btn__content) {
    font-size: 12px !important;
    text-transform: capitalize;
  }

  :deep(.selected) {
    border: 1px solid $bb-primary-3 !important;
  }
}

.smaller-elements {
  :deep(.bb-btn.secondary) {
    padding: $bb-spacing-2 !important;
    height: $bb-spacing-6 !important;
  }

  :deep(.v-btn__content) {
    gap: $bb-spacing-1 !important;
  }
}
</style>
